<template>
  <div v-cloak>
    <canvas id="programCanvas" ref="programCanvas"></canvas>  
  </div>
</template>

<script>
  export default {
    name: 'program',
    
    props: {
      program: Object,
      mode: String,
      activeInterval: Number,
      intervals: Array,

    },
    data() {
      return {
        ctx:undefined,
        width:0,
        height:0,
        scaleX:0,
        scaleY:0,
        startColumn:-1,
        endColumn:-1,
      }
    },
    methods: {
      renderProgram() {
        this.startColumn = 0;
        this.endColumn = this.intervals.length-1;
        this.ctx.clearRect(0,0,this.width, this.height);
        
        if (this.mode == "setup") {
          this.ctx.fillStyle = "#408df7";
        }

        var step = 0;
        
        const segments = this.intervals.length<5?5:this.intervals.length;
        const segmentGaps = segments -1;
        const segmentWidth = (this.width/segments) * .8;
        const segmentGapWidth = (this.width/segmentGaps) * .1;
        const segmentStartOffset = (this.width/segments) * segments / 20;
        
        const zones = 5;
        const zoneGaps = zones -1;
        const zoneHeight = (this.height / zones) * .7;
        const zoneGapHeight = (this.height / zoneGaps) * .1;
        const zoneStartOffset = (this.height/zones) * zones / 10;

        while (step < segments && step <= this.endColumn) {
          if (this.mode == "running" || this.mode == "paused") {
            if (step == this.activeInterval) {
              this.ctx.fillStyle = "#408df7";  
            }
            else {
              this.ctx.fillStyle = "#1c238a";
            }
          }
          const x1 = segmentStartOffset + (segmentWidth * step + segmentGapWidth*step);
          for (var i=0; i<this.intervals[step].zone;i++) {
            const y1 = this.height - zoneHeight - (zoneStartOffset + (zoneHeight * i + zoneGapHeight*i));
            this.ctx.fillRect(x1, y1, segmentWidth, zoneHeight);
          }

          step++;
        }
      },
    },
    computed: {
    },
    watch: {
      activeInterval() {
        this.renderProgram();
      },
      program() {
        if (this.program.intervals.length>0) {
          this.renderProgram();
        }
      },
      "program.time"() {
        this.$nextTick(function() {
          this.renderProgram();
        }
      )},
      mode() {
        if (this.program.intervals.length>0) {
          this.renderProgram();
        }
      }

    },
    mounted() {
      this.$nextTick(function() {
        this.width = this.$refs.programCanvas.parentNode.offsetWidth;
        this.height = this.$refs.programCanvas.parentNode.offsetHeight;
        this.$refs.programCanvas.width = this.width;
        this.$refs.programCanvas.height = this.height;
        this.ctx = this.$refs.programCanvas.getContext("2d");
        this.ctx.strokeStyle = "white"
        this.ctx.lineWidth = 6;
        this.renderProgram();
        

        window.addEventListener("resize",() => {
          if (this.$refs.programCanvas != null) {
            this.ctx.clearRect(0,0,this.width, this.height);
            this.width = this.$refs.programCanvas.parentNode.offsetWidth;
            this.height = this.$refs.programCanvas.parentNode.offsetHeight;
            this.$refs.programCanvas.width = this.width;
            this.$refs.programCanvas.height = this.height;
            this.ctx.strokeStyle = "white"
            this.ctx.lineWidth = 6;
            this.renderProgram();
          }
        })
      })
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
